import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
const automationTiers = [{
  key: 'start',
  name: 'START',
  desc: 'Para comenzar a automatizar.',
  setup: '$1.200.000',
  monthly: '$300.000/mes',
  featured: false,
  whatsapp: 'Hola ORIGEN, quiero conocer el sistema START.'
}, {
  key: 'growth',
  name: 'GROWTH',
  badge: 'MÁS ELEGIDO',
  desc: 'Para convertir la atención en un proceso comercial.',
  setup: '$2.500.000',
  monthly: '$650.000/mes',
  featured: true,
  whatsapp: 'Hola ORIGEN, quiero conocer GROWTH.'
}, {
  key: 'pro',
  name: 'PRO',
  desc: 'Para empresas con procesos más complejos.',
  setup: '$4.500.000',
  monthly: '$1.200.000/mes',
  featured: false,
  whatsapp: 'Hola ORIGEN, quiero conocer PRO.'
}];
export function ThreeSystems() {
  return <section id="sistemas" className="bg-arena py-[72px] md:py-[120px]" data-id="element-211" data-mp="2okdvqzy6j0zb">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-212" data-mp="1wxlo4rt72wro">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-14 md:mb-16 text-center max-w-[600px] mx-auto" data-id="element-213" data-mp="1wuzg6r2e6f8x">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-214" data-mp="2bnkjynxa1w3z">
            ¿QUÉ NECESITAS CONSTRUIR?
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1]" data-id="element-215" data-mp="1ixknndgudrcq">
            Un sistema que se adapte a tu empresa.
          </h2>
        </motion.div>

        {/* Presencia Digital — standalone */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-arena-dark border border-salvia/25 rounded-[12px] p-8 md:p-9 flex flex-col md:flex-row md:items-center gap-6 md:gap-10 mb-6" data-id="element-216" data-mp="1ssvvdbtu1yaz">
          <div className="flex-1" data-id="element-217" data-mp="z8t6ta8grhuv">
            <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-3" data-id="element-218" data-mp="1d8kekt8e020f">
              PRESENCIA DIGITAL
            </span>
            <h3 className="font-display text-[20px] font-bold text-carbon mb-2 leading-[1.2]" data-id="element-219" data-mp="197qpvxn4ej6h">
              Construye una presencia que convierta.
            </h3>
            <p className="font-body text-[14px] text-carbon/65 leading-[1.6] max-w-[440px]" data-id="element-220" data-mp="gjcrhgs4dkue">
              Webs y experiencias digitales diseñadas para representar tu
              empresa y convertir visitantes en oportunidades.
            </p>
          </div>
          <div className="flex flex-col md:items-end gap-4 flex-shrink-0" data-id="element-221" data-mp="phex69mst1o0">
            <div className="md:text-right" data-id="element-222" data-mp="1rufrv6amcgu">
              <div data-id="element-223" data-mp="3txpym9bzowa5">
                <span className="font-display text-[20px] font-bold text-carbon" data-id="element-224" data-mp="3twes41r5tafc">
                  Desde $3.500.000
                </span>
                <span className="font-body text-[13px] text-carbon/50 ml-1.5" data-id="element-225" data-mp="3jrg8lqoouctl">
                  implementación
                </span>
              </div>
              <div className="mt-0.5" data-id="element-226" data-mp="39w4u99h6z7md">
                <span className="font-body text-[13px] font-medium text-carbon/70" data-id="element-227" data-mp="39x6f25o0f8ha">
                  Desde $250.000/mes
                </span>
                <span className="font-body text-[12px] text-carbon/40 ml-1" data-id="element-228" data-mp="6e3f0f9eaum6">
                  mantenimiento opcional
                </span>
              </div>
            </div>
            <a href={getWhatsAppLink('Hola, quiero hablar con ORIGEN sobre Presencia Digital.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] bg-verde text-arena hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta transition-all duration-200 whitespace-nowrap" data-id="element-229" data-mp="3sluxmkz0t1pw">
              Explorar <ArrowRight size={15} className="ml-1.5" data-id="element-230" data-mp="32eqbkj3crbfn" />
            </a>
          </div>
        </motion.div>

        {/* Automatización — 3 tiers */}
        <div className="mb-6" data-id="element-231" data-mp="2so5fb2b5iizw">
          <div className="text-center mb-6 mt-10" data-id="element-232" data-mp="2skztpx1qdz8x">
            <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-2" data-id="element-233" data-mp="2nosltyprydoc">
              AUTOMATIZACIÓN
            </span>
            <p className="font-body text-[14px] text-carbon/55 max-w-[440px] mx-auto" data-id="element-234" data-mp="3l9oufuyvk2k5">
              IA + WhatsApp + CRM + automatizaciones para atender, calificar
              y hacer seguimiento.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-id="element-235" data-mp="36f0j406sm9wm">
            {automationTiers.map((tier, idx) => <motion.div key={tier.key} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.4,
            ease: 'easeOut',
            delay: idx * 0.08
          }} className={`relative flex flex-col rounded-[12px] p-7 md:p-8 transition-all duration-200 ${tier.featured ? 'bg-verde text-arena md:-translate-y-2 shadow-cta border border-verde' : 'bg-arena-dark text-carbon border border-carbon/10 hover:border-verde/40 hover:-translate-y-[2px] hover:shadow-card'}`} data-id="element-236" data-mp="1zz7yz4qi2w9s" data-mpi={idx}>
                {tier.badge && <span className="absolute -top-3 left-1/2 -translate-x-1/2 font-body text-[11px] font-semibold uppercase tracking-[0.1em] px-3 py-1 rounded-full bg-azul text-arena whitespace-nowrap" data-id="element-237" data-mp="136i0q0kpydk0">
                    {tier.badge}
                  </span>}
                <h4 className={`font-display text-[18px] font-bold mb-2 ${tier.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-238" data-mp="39xhjn1aca5px">
                  {tier.name}
                </h4>
                <p className={`font-body text-[13px] leading-[1.6] mb-6 flex-grow ${tier.featured ? 'text-arena/80' : 'text-carbon/60'}`} data-id="element-239" data-mp="2xvgitbp4k2xz">
                  {tier.desc}
                </p>
                <div className={`h-px w-full mb-5 ${tier.featured ? 'bg-arena/20' : 'bg-carbon/10'}`} data-id="element-240" data-mp="36tifjf1ts9fg" />
                <div className="mb-6" data-id="element-241" data-mp="3gt98hcaqmgdf">
                  <span className={`font-display text-[20px] font-bold ${tier.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-242" data-mp="3gs7zddda83yc">
                    {tier.setup}
                  </span>
                  <span className={`font-body text-[12px] ml-1.5 ${tier.featured ? 'text-arena/60' : 'text-carbon/45'}`} data-id="element-243" data-mp="3pm32kfuufkbc">
                    implementación
                  </span>
                  <div data-id="element-244" data-mp="3ca2d8i1lxr2">
                    <span className={`font-body text-[14px] font-medium ${tier.featured ? 'text-arena/85' : 'text-carbon/70'}`} data-id="element-245" data-mp="mzd94q62nguf">
                      {tier.monthly}
                    </span>
                  </div>
                </div>
                <a href={getWhatsAppLink(tier.whatsapp)} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] transition-all duration-200 ${tier.featured ? 'bg-arena text-verde hover:bg-[#EAE7E0]' : 'bg-verde text-arena hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta'}`} data-id="element-246" data-mp="i0tiwdkg3iw9">
                  Explorar <ArrowRight size={15} className="ml-1.5" data-id="element-247" data-mp="3gkikjrywzvwe" />
                </a>
              </motion.div>)}
          </div>
        </div>

        {/* Sistema Completo — integral option, separated below */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="relative mt-10 bg-carbon rounded-[12px] p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-6 md:gap-10" data-id="element-248" data-mp="ski8v0e799w">
          <span className="absolute -top-3 left-8 font-body text-[11px] font-semibold uppercase tracking-[0.1em] px-3 py-1 rounded-full bg-azul text-arena" data-id="element-249" data-mp="3i28trp24susv">
            ORIGEN SYSTEM
          </span>
          <div className="flex-1" data-id="element-250" data-mp="398vs9yq04kv6">
            <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-salvia mb-3" data-id="element-251" data-mp="395zxgj9gacay">
              SISTEMA COMPLETO
            </span>
            <h3 className="font-display text-[22px] font-bold text-arena mb-2 leading-[1.2]" data-id="element-252" data-mp="2z8v6m64ntsnt">
              Presencia + automatización. Un solo sistema.
            </h3>
            <p className="font-body text-[14px] text-arena/70 leading-[1.6] max-w-[460px]" data-id="element-253" data-mp="2k7odex6rfu2a">
              Construimos tu presencia digital y conectamos todo lo que
              sucede después de que alguien muestra interés.
            </p>
          </div>
          <div className="flex flex-col md:items-end gap-4 flex-shrink-0" data-id="element-254" data-mp="2u39k38mrxiid">
            <span className="font-display text-[20px] font-bold text-arena md:text-right" data-id="element-255" data-mp="2z347h27cbpyo">
              Desde $4.500.000 + $500.000/mes
            </span>
            <a href={getWhatsAppLink('Hola, quiero construir un Sistema Completo con ORIGEN.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] bg-arena text-carbon hover:bg-[#EAE7E0] hover:-translate-y-[1px] transition-all duration-200 whitespace-nowrap" data-id="element-256" data-mp="26fi702tet1g1">
              Construir mi sistema <ArrowRight size={15} className="ml-1.5" data-id="element-257" data-mp="36j3rq2b5feup" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}